export const HEADER_CELLS = [
  "A1",
  "A2",
  "A6",
  "A7",
  "A9",
  "A12",
  "A14",
  "A17",
  "A19",
  "A24",
  "A26",
  "A29",
  "A33",
  "B9"
];

export const CONTENT_CELLS = [
  "A3",
  "A4",
  "A5",
  "A10",
  "A11",
  "A15",
  "A16",
  "A20",
  "A21",
  "A22",
  "A23",
  "A27",
  "A28",
  "A31",
  "A32",
  "B1",
  "B6",
  "B7",
  "B10",
  "B11",
  "B12",
  "B15",
  "B16",
  "B17",
  "B20",
  "B21",
  "B22",
  "B23",
  "B24",
  "B27",
  "B28",
  "B29",
  "B31",
  "B32",
  "B33"
];

export const ITALICIZED_CELLS = ["B3", "B4", "B5"];

export const SUMMARY_BOLD_STLYES = {
  font: {
    bold: "true",
    sz: "11"
  }
};

export const SUMMARY_CONTENT_NAMES_STYLES = {
  // mall name, brand name, company name
  font: {
    italic: "true",
    sz: "11"
  }
};

export const SUMMARY_REGULAR_CONTENT_STYLES = {
  alignment: {
    horizontal: "left"
  },
  font: {
    sz: "11"
  }
};

export const COLOR = {
  BLACK: "000000",
  LEMON: "FFE6A7",
  WHITE: "FFFFFF"
};

export const FORMAT = {
  CURRENCY: "#,##0.00",
  DATE: "yyyy-mm-dd",
  GENERAL: "General"
};

export const ORDER_DETAILS_CONTENT_STYLES = {
  alignment: {
    vertical: "center"
  },
  border: {
    bottom: { color: { rgb: COLOR.BLACK }, style: "thin" },
    left: { color: { rgb: COLOR.BLACK }, style: "thin" },
    right: { color: { rgb: COLOR.BLACK }, style: "thin" },
    top: { color: { rgb: COLOR.BLACK }, style: "thin" }
  },
  fill: {
    fgColor: { rgb: COLOR.WHITE },
    patternType: "solid"
  },
  font: {
    sz: "11"
  },
  numFmt: FORMAT.GENERAL
};

export const ORDER_DETAILS_HEADER_STYLES = {
  alignment: {
    horizontal: "center",
    vertical: "center"
  },
  border: {
    bottom: { color: { rgb: COLOR.BLACK }, style: "thin" },
    left: { color: { rgb: COLOR.BLACK }, style: "thin" },
    right: { color: { rgb: COLOR.BLACK }, style: "thin" },
    top: { color: { rgb: COLOR.BLACK }, style: "thin" }
  },
  fill: {
    fgColor: { rgb: COLOR.LEMON },
    patternType: "solid"
  },
  font: {
    bold: "true",
    sz: "11"
  }
};
